// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
// =========================

export default function Button({
    children,
    onClick,
    background = '#1E265C',
    color,
    border = background,
    style,
}) {
    return (
        <motion.button
            styleName="button"
            onClick={onClick}
            type="submit"
            style={{
                ...style,
                backgroundColor: background,
                color,
                border: `3px solid ${border}`,
            }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
        >
            {children}
        </motion.button>
    );
}
